import React from 'react';
import { AwardIcon, DoorOpenIcon, GlobeIcon, UsersIcon } from 'lucide-react';
import { trustFacts } from '../data/content';
const iconMap = {
  award: AwardIcon,
  door: DoorOpenIcon,
  users: UsersIcon,
  globe: GlobeIcon
};
export function TrustBar() {
  return <section aria-label="Lima Dental Group practice information" className="bg-ink-soft" data-id="element-457" data-mp="y6wckghwngf3">
      <div className="mx-auto max-w-shell px-5 sm:px-8 lg:px-12" data-id="element-458" data-mp="135pnq29pyvc3">
        <dl className="grid grid-cols-1 divide-y divide-white/10 sm:grid-cols-2 sm:divide-y-0 lg:grid-cols-4" data-id="element-459" data-mp="1qyprm4m89vup">
          {trustFacts.map((fact, index) => {
          const Icon = iconMap[fact.icon];
          return <div key={fact.label} className={`flex items-start gap-4 py-9 lg:py-16 ${index > 0 ? 'lg:border-l lg:border-white/10 lg:pl-10' : ''} ${index % 2 === 1 ? 'sm:border-l sm:border-white/10 sm:pl-10' : ''}`} data-id="element-460" data-mp="1h1bd4ajv7h51" data-mpi={index}>
                <Icon aria-hidden="true" className="mt-1.5 h-5 w-5 shrink-0 text-white/40" strokeWidth={1.25} data-id="element-461" data-mp="ah20w29bnxwf" />
                <div data-id="element-462" data-mp="16iwl9azglda9">
                  <dt className="font-display text-[clamp(1.6rem,2.4vw,2.1rem)] leading-[1.1] text-white" data-id="element-463" data-mp="16jodcbtuksvs">
                    {fact.value}
                  </dt>
                  <dd className="mt-2.5 text-[14.5px] text-white/55" data-id="element-464" data-mp="1fh8j9y2nndcq">{fact.label}</dd>
                </div>
              </div>;
        })}
        </dl>
      </div>
    </section>;
}